import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  reportAlarmsState,
  reportFilterGroupState,
  reportSearchTypeState,
  reportViewState,
} from '../../../storage/reports';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import AlarmsReports from '../../reports/alarmsReport/AlarmsReports';
import AlarmsReportsByGroup from '../../reports/alarmsReport/AlarmsReportsByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function AlarmsReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const hasStates = !!useRecoilValue(reportAlarmsState(groupId))?.length;
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <AlarmsReports />}
            {isGroupReportView && <AlarmsReportsByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={isGroupReportView && hasStates ? 850 : 550}
    />
  );
}

export default AlarmsReportsPage;
